/**
 * Approvals — a single view that merges "Quote approvals" and "Invoice & receipt
 * reviews" into two tabs (saves a nav slot). Each tab lazy-mounts the existing
 * view module into its own panel; the nav badge sums both pending counts.
 */
import { escapeHtml } from '../../src/lib/format.js';
import { hasRole } from '../../src/lib/roles.js';
import * as api from '../api-client.js';
import * as review from './invoicing-review.js';   // mountReview(container)
import * as quotes from './crm-quotes.js';          // mountInbox(container)

const API = api.routes;

let activeTab = null;
let mountedTabs = {};

function canQuotes() { return hasRole('root', 'sales_supervisor'); }
function canInvoices() { return hasRole('root', 'finance_manager', 'sales_supervisor', 'billing_supervisor'); }

export async function mountReviews(container) {
  container = container || document.getElementById('invoicingReviewsView');
  if (!container) return;
  mountedTabs = {};
  const tabs = [];
  if (canQuotes()) tabs.push(['quotes', 'Quotes']);
  if (canInvoices()) tabs.push(['invoices', 'Invoices & receipts']);
  if (!tabs.length) {
    container.innerHTML = '<div class="crm-detail-empty">You don’t have access to approvals or reviews.</div>';
    return;
  }
  if (!tabs.some((t) => t[0] === activeTab)) activeTab = tabs[0][0];

  container.innerHTML = `
    <div class="row" style="gap:6px; margin-bottom:10px;">
      ${tabs.map(([k, l]) => `<button class="btn ${k === activeTab ? 'primary' : 'ghost'}" data-rtab="${k}">${escapeHtml(l)}</button>`).join('')}
    </div>
    <div data-rpanel="quotes" style="display:none;"></div>
    <div data-rpanel="invoices" style="display:none;"></div>`;

  container.querySelectorAll('[data-rtab]').forEach((b) =>
    b.addEventListener('click', () => select(container, b.dataset.rtab)));
  await select(container, activeTab);
}

async function select(container, tab) {
  activeTab = tab;
  container.querySelectorAll('[data-rtab]').forEach((b) => {
    const on = b.dataset.rtab === tab;
    b.classList.toggle('primary', on);
    b.classList.toggle('ghost', !on);
  });
  container.querySelectorAll('[data-rpanel]').forEach((p) => {
    p.style.display = p.dataset.rpanel === tab ? '' : 'none';
  });
  const panel = container.querySelector(`[data-rpanel="${tab}"]`);
  if (tab === 'quotes' && !mountedTabs.quotes) {
    mountedTabs.quotes = true;
    if (typeof quotes.mountInbox === 'function') await quotes.mountInbox(panel);
  }
  if (tab === 'invoices' && !mountedTabs.invoices) {
    mountedTabs.invoices = true;
    if (typeof review.mountReview === 'function') await review.mountReview(panel);
  }
}

export async function refreshBadge() {
  let total = 0;
  if (canQuotes()) {
    try {
      const d = await api.fetch(API.crmQuoteApprovalsInbox('status=pending&limit=1'), { method: 'GET' });
      total += (d.total != null ? d.total : (d.items || []).length);
    } catch (err) { /* non-fatal */ }
  }
  if (canInvoices()) {
    try {
      const d = await api.fetch(API.invoicingApprovalsInbox('status=pending'), { method: 'GET' });
      total += (d.items || []).length;
    } catch (err) { /* non-fatal */ }
  }
  const badge = document.getElementById('invoicingReviewsBadge');
  if (badge) { badge.textContent = total > 0 ? String(total) : ''; badge.style.display = total > 0 ? '' : 'none'; }
}

export default { mountReviews, refreshBadge };
